import React, { useContext } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'




import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'
import MerkleTree from '../../comonents/MerkleTree';






export default function Game2MerkleTreePage() {

    const navigate = useNavigate();

    const { userInfo, privateID } = useContext(Context);


    function toRole() {
        navigate('/role')
    }
    return (
        <div>
            <TitleBar backLastPage="" lastPageName="game2hashcalculation" />
            <div className='text-center'>
                <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>Merkle Tree Rule</p></b>
            </div>

            {/* MerkleTree */}
            <MerkleTree />
            {/* MerkleTree */}


            <div className='MerkleText'>
                <div className='text-center'><b>The Rule of Merkle Tree:</b></div>

                Hash 1 = DV(Data 1 + Previous Merkle Tree Root)*10 + Nonce<br />
                Hash 2 = DV(Data 2 + Previous Merkle Tree Root)*10 + Nonce<br />
                Hash 3 = DV(Data 3 + Previous Merkle Tree Root)*10 + Nonce<br />
                Hash 4 = DV(Data 4 + Previous Merkle Tree Root)*10 + Nonce<br />
                Hash 12 = DV(Hash 1 + Hash 2)*10 + Nonce<br />
                Hash 34 = DV(Hash 3 + Hash 4)*10 + Nonce<br />
                Hash 1234 = DV(Hash 12 + Hash 34)*10 + Nonce [*Merkle Tree Root]<br /><br />

            </div>

            <br />

            <div className="ruleForHashGame2_div_Next">
                <input className="ruleForHashGame2_btn_Next" type="button" value="Start" onClick={e => toRole()} />
            </div>







        </div >
    )
}